import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const EgyptPage = () => {
  return <DestinationTemplate destinationId="egypt" />;
};

export default EgyptPage;
